import { AfterViewInit, Component, Inject, Input, Optional, ViewChild } from "@angular/core";
import { NG_ASYNC_VALIDATORS, NG_VALIDATORS, NG_VALUE_ACCESSOR, NgModel } from "@angular/forms";
import { ValueAccessorBase } from "../../../objects/common/valueAccessorBase";

@Component({
    selector: 'radio',
    templateUrl: './radio.component.html',
    moduleId: module.id.toString(),
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: RadioComponent, multi: true }
    ],
})
export class RadioComponent extends ValueAccessorBase<string> implements AfterViewInit {
    @Input() public name: string;
    @Input() public label: string;
    @Input() public radioValue: string;
    @Input() public disabled: boolean;

    @ViewChild(NgModel) model: NgModel;

    constructor(@Optional() @Inject(NG_VALIDATORS) private validators: Array<any>, @Optional() @Inject(NG_ASYNC_VALIDATORS) private asyncValidators: Array<any>) {
        super();
    }

    ngAfterViewInit() {
        this.model.control.setValidators(this.validators);
        this.model.control.setAsyncValidators(this.asyncValidators);
    }
}


// WEBPACK FOOTER //
// ./app/components/common/radio/radio.component.ts